import { Button } from '@cian/ui-kit/button';
import { ModalWindow } from '@cian/ui-kit/modal';
import { InlineText2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './styles.css';

interface IErrorProps {
  onClose(): void;
  isMobile: boolean;
}

export function Error({ onClose, isMobile }: IErrorProps) {
  return (
    <ModalWindow
      open={true}
      onClose={onClose}
      maxWidth={448}
      title="Ошибка!"
      content={<InlineText2>Не удалось отправить заявку. Пожалуйста, попробуйте позже</InlineText2>}
      footer={
        <div className={styles['footer']}>
          <Button onClick={onClose} size={isMobile ? 'M' : 'XS'}>
            Хорошо
          </Button>
        </div>
      }
    />
  );
}
